<!--  -->
<template>
    <div class='box box_f1 box_between'>
        <div class="wrapper box_f1 box box_v">
            <div class="title">银行办件排名TOP5</div>
            <div v-for="(item,index) in list1" :key="index" class="item box_f1 box">
                <div class="rank rank1">{{index+1}}</div>
                <div class="box_f1">
                    <div class="box">
                        <div class="title1 box_f1">{{item.name}}</div>
                        <div class="number1 number">{{item.handleCount}}件</div>
                    </div>
                    <div class="line_bg">
                        <div class="line line1" :style="{width:item.width}"></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="wrapper box_f1 box box_v">
            <div class="title">开发商办件排名TOP5</div>
            <div v-for="(item,index) in list2" :key="index" class="item box_f1 box">
                <div class="rank rank2">{{index+1}}</div>
                <div class="box_f1">
                    <div class="box">
                        <div class="title2 box_f1">{{item.name}}</div>
                        <div class="number2 number">{{item.handleCount}}件</div>
                    </div>
                    <div class="line_bg">
                        <div class="line line2" :style="{width:item.width}"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
    props:['communityId'],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
    //这里存放数据
        return {
            list1:[],
            list2:[],
            communityIds:1
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        communityId:{
            handler(newVal){
                if(this.communityIds != newVal){
                    this.communityIds = newVal;
                    this.getBankData(this.communityIds)
                    this.getDevelopData(this.communityIds)
                }
            },
            deep:true
        }
    },
    //方法集合
    methods: {
        getBankData(communityId){
            this.$get(this.urlobj.estateTop5,{
                type:'bank',
                communityId:communityId
            }).then(res=>{
                let maxNum = res.rows[0].handleCount
                this.list1 = res.rows.splice(0,5).map(item=>{
                    return {
                        name:item.name,
                        handleCount:item.handleCount.toLocaleString(),
                        width:(item.handleCount/maxNum).toFixed(2)*100 + '%'
                    }
                })
            })
        },
        getDevelopData(communityId){
            this.$get(this.urlobj.estateTop5,{
                type:'develop',
                communityId:communityId
            }).then(res=>{
                let maxNum = res.rows[0].handleCount
                this.list2 = res.rows.splice(0,5).map(item=>{
                    return {
                        name:item.name,
                        handleCount:item.handleCount.toLocaleString(),
                        width:(item.handleCount/maxNum).toFixed(2)*100 + '%'
                    }
                })
            })
        }
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getBankData(this.communityIds)
        this.getDevelopData(this.communityIds)
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {}, //生命周期 - 创建之前
    beforeMount() {}, //生命周期 - 挂载之前
    beforeUpdate() {}, //生命周期 - 更新之前
    updated() {}, //生命周期 - 更新之后
    beforeDestroy() {}, //生命周期 - 销毁之前
    destroyed() {}, //生命周期 - 销毁完成
    activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
    }
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.wrapper{
    background-image: url('../../../../assets/images/monitorpy/bottom.png');
    background-size: 100% 100%;
    padding:20px;
    margin-top: 5px;
}
.wrapper:first-child{
    margin-right:10px;
}
.wrapper:last-child{
    margin-left:10px
}
.title{
    height: 18px;
    font-size: 18px;
    font-weight: bold;
    color: #FFFFFF;
    margin:10px 0 0 20px
}
.item{
    align-items: center;
    margin-top: 20px;
    .rank{
        width: 25px;
        height: 25px;
        line-height: 25px;
        background: #061B54;
        border-radius: 6px;
        text-align: center;
        color:#fff;
        margin-right:10px
    }
    .rank1{
         border:1px solid #008cff;
    }
    .rank2{
        border:1px solid #00EFE1;
    }
    .title1{
        font-size: 14px;
        color:#23e0f1
    }
    .title2{
        font-size: 14px;
        color:#9ae8d7
    }
    .number{
        font-size: 16px;
        font-style: italic;
        
        font-weight: bold;
        padding-right:4px
    }
    .number1{
        color: #B3DDFF;
        background: linear-gradient(0deg, #00F6FF 0%, #0290FE 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

    }
    .number2{
        color: #FFFFFF;
        background: linear-gradient(0deg, #00D8B7 0%, #00C38A 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
    .line_bg{
        width: 100%;
        height: 9px;
        background: #1D3370;
        border-radius: 5px;
        position: relative;
    }
    .line{
        height: 9px;
        border-radius: 5px;
    }
    .line1{
        background: linear-gradient(90deg, #0290FE 0%,#00F6FF 100%);
    }
    .line2{
        background: linear-gradient(90deg, #00C38A 0%, #00D8B7 100%);
    }
}
</style>